import { CART_SYNC_START, CART_SYNC_SUCCESS, CART_SYNC_FAIL } from "./actions";

const initialState = {
  isSyncing: false,
  hasError: false,
  positions: [],
};

export default function cart(state = initialState, action) {
  switch (action.type) {
    case CART_SYNC_START:
      return {
        ...state,
        isSyncing: true,
      };

    case CART_SYNC_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isSyncing: false,
        hasError: false,
      };

    case CART_SYNC_FAIL:
      return {
        ...state,
        isSyncing: false,
        hasError: true,
      };

    default:
      return state;
  }
}

export * from "./actions";
export * from "./selectors";
